import ReservationCard from "~/components/Admin/Reports/ReportsReservations/ReservationCard"

const ReservationsCardList = ({ data, camp, isCollectingTax, isCollectingCreditCardFee }) => {
  return (
    <div className="py-1">
      {data &&
        data.map((reservationData, index) => (
          <ReservationCard
            key={index}
            reservationData={reservationData}
            camp={camp}
            isCollectingTax={isCollectingTax}
            isCollectingCreditCardFee={isCollectingCreditCardFee}
          />
        ))}
    </div>
  )
}

export default ReservationsCardList
